import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { qk } from '@/lib/queryKeys';
import type { ThresholdTable } from '@/lib/thresholds';
import type { ColorTiers } from '@/lib/waterColor';
import { useCurrentFarm } from './useCurrentFarm';

export interface FarmThresholdsData {
  effective: ThresholdTable;
  defaults: ThresholdTable;
  overrides: Record<string, Partial<ThresholdTable[string]>>;
  water_color_tiers?: ColorTiers;
}

/** The farm's band table. `table` is undefined until it loads: colour nothing on a guess. */
export function useFarmThresholds(farmIdOverride?: string | null) {
  const { farmId: currentFarmId } = useCurrentFarm();
  const farmId = farmIdOverride ?? currentFarmId;
  const query = useQuery({
    queryKey: qk.thresholds.farm(farmId),
    queryFn: () =>
      api
        .get<{ data: FarmThresholdsData }>(`/api/v1/farms/${farmId}/thresholds`)
        .then((r) => r.data),
    enabled: !!farmId,
    staleTime: 5 * 60_000,
  });
  return { ...query, table: query.data?.effective, colorTiers: query.data?.water_color_tiers, farmId };
}
